import {
  useDcListQuery,
  useSellableItemListQuery,
  useSellableListSubItemsQuery,
} from "generated/graphql"
import { useSearchFilter } from "hooks/searchFilterHooks"

export const useDCList = () => {
  const [{ date, page }] = useSearchFilter()

  const { data, loading, refetch } = useDcListQuery({
    variables: {
      first: 15,
      skip: page * 15,
      date,
    },
  })

  return { data, loading, refetch }
}

export const useSellableItemList = () => {
  const [{ date, type, page }] = useSearchFilter()

  let filter: any = {
    //isSku: false,
    excludeItemCategory: [6],
  }

  if (type === "rpg") {
    filter = {
      //isSku: true,
    }
  }

  if (type === "raw-material") {
    filter = {
      // isSku: false,
      includeItemCategory: [6],
    }
  }

  const { data, loading, refetch } = useSellableItemListQuery({
    variables: {
      date,
      filter,
      first: 15,
      skip: page * 15,
    },
  })

  return { data, loading, refetch }
}

export const useSellableListSubItems = () => {
  const [{ date }] = useSearchFilter()

  const { data, loading, refetch } = useSellableListSubItemsQuery({
    variables: {
      date,
    },
  })

  return { data, loading, refetch }
}
